module.exports = __webpack_public_path__ + "history.png";